<div class="number-range">
  <span class="range-label" *ngIf="label">{{ label | translate }}</span>
  <div class="range-fields">
    <mat-form-field class="range-field">
      <mat-label>{{ minLabel | translate }}</mat-label>
      <input matInput type="text" [appNumberInput]="mode" [maxDecimals]="maxDecimals ?? undefined"
        [ngModel]="min" (ngModelChange)="onMin($event)" [min]="floor" [max]="max"
        [errorStateMatcher]="errorStateMatcher" [aria-describedby]="invalid ? errorsId : ''">
    </mat-form-field>
    <mat-form-field class="range-field">
      <mat-label>{{ maxLabel | translate }}</mat-label>
      <input matInput type="text" [appNumberInput]="mode" [maxDecimals]="maxDecimals ?? undefined"
        [ngModel]="max" (ngModelChange)="onMax($event)" [min]="maxFieldMin"
        [errorStateMatcher]="errorStateMatcher" [aria-describedby]="invalid ? errorsId : ''">
    </mat-form-field>
  </div>
  <!-- Permanent and polite: only its text changes, so a screen reader announces a rule breaking.
       Both inputs point at it through MatInput's aria-describedby input while it holds a message
       (MatInput owns the attribute and merges it with the form field's own ids). -->
  <div class="range-errors" [id]="errorsId" aria-live="polite">
    <span class="range-error" *ngFor="let key of errors">{{ key | translate }}</span>
  </div>
</div>
